import { ByteArray } from "../ByteArray"
import { ICommand } from "./ICommand"

export class CMDScRequestFail implements ICommand
{

	public Error : number = 0;

	public constructor()
	{
	}

	public fromBytes(ba : ByteArray) : void
	{
		this.Error = ba.readUint8();
	}

	public toBytes() : ByteArray
	{
		let ba: ByteArray = new ByteArray();

		ba.writeUint8(this.Error);

		return ba;
	}

	public clone() : ICommand
	{
		let cmd : ICommand = new CMDScRequestFail();
		cmd.fromBytes(this.toBytes());

		return cmd;
	}

	public toString() : string
	{
		let str:string = '';
		str += 'Error(B)='+this.Error+' ';
		return str;
	}

	public getCmdID() : number
	{
		return 30001;
	}

	public getCmdName() : string
	{
		return 'ScRequestFail';
	}

}
